import React from "react";

const ServicePageSkeleton = ({ numberOfCols = 3, isTitle }: any) => {
  const cols = typeof numberOfCols === "number" ? numberOfCols : 3;

  return (
    <section className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8 cht-py-10">
      {isTitle && (
        <header className="cht-text-center cht-mb-10 cht-space-y-3">
          <div className="cht-h-8 cht-w-56 cht-bg-slate-200 cht-rounded-xl cht-mx-auto cht-animate-pulse" />
          <div className="cht-h-4 cht-w-80 cht-bg-slate-100 cht-rounded-lg cht-mx-auto cht-animate-pulse" />
        </header>
      )}

      <div className="cht-grid cht-grid-cols-1 md:cht-grid-cols-2 lg:cht-grid-cols-3 cht-gap-6 sm:cht-gap-8">
        {Array.from({ length: cols }).map((_, index) => (
          <div
            key={index}
            className="cht-bg-white cht-rounded-[20px] cht-border cht-border-slate-200/80 cht-overflow-hidden cht-shadow-soft cht-animate-pulse"
          >
            {/* 16:9 Aspect Ratio Media Placeholder */}
            <div className="cht-aspect-[16/9] cht-bg-slate-200/80 cht-w-full" />

            {/* Content Body Placeholder */}
            <div className="cht-p-5 sm:cht-p-6 cht-space-y-3.5">
              <div className="cht-h-5 cht-bg-slate-200 cht-rounded-lg cht-w-3/4" />
              <div className="cht-space-y-2 cht-pt-1">
                <div className="cht-h-3.5 cht-bg-slate-100 cht-rounded-md cht-w-full" />
                <div className="cht-h-3.5 cht-bg-slate-100 cht-rounded-md cht-w-5/6" />
                <div className="cht-h-3.5 cht-bg-slate-100 cht-rounded-md cht-w-3/5" />
              </div>
              <div className="cht-pt-4 cht-border-t cht-border-slate-100 cht-flex cht-items-center cht-justify-between">
                <div className="cht-h-4 cht-bg-slate-200 cht-rounded-md cht-w-28" />
                <div className="cht-h-3.5 cht-bg-slate-100 cht-rounded-md cht-w-20" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicePageSkeleton;
